export const SELECT_CHART = 'SELECT_CHART';
export const SELECT_CHART_TYPE = 'SELECT_CHART_TYPE';
export const TOGGLE_RETIREMENT_SHOW_AS = 'TOGGLE_RETIREMENT_SHOW_AS';
export const FETCH_RI_SCENARIO = 'FETCH_RI_SCENARIO';
export const FETCH_RI_SCENARIO_SUCCESS = 'FETCH_RI_SCENARIO_SUCCESS';
export const FETCH_RI_SCENARIO_ERROR = 'FETCH_RI_SCENARIO_ERROR';
export const UPDATE_RI_SCENARIO = 'UPDATE_RI_SCENARIO';
export const POST_SIMULATION = 'POST_SIMULATION';

export const fetchRIScenario = () => ({
  type: FETCH_RI_SCENARIO,
});

export const fetchRIScenarioSuccess = (payload: any) => ({
  type: FETCH_RI_SCENARIO_SUCCESS,
  payload,
});
export const fetchRIScenarioError = (payload: any) => ({
  type: FETCH_RI_SCENARIO_ERROR,
  payload,
});

export const updateRIScenario = (payload: any) => ({
  type: UPDATE_RI_SCENARIO,
  payload,
});
